import { selectTimesheetRows } from '@web/redux/selectors';
import { useAppSelector } from '@web/redux/store';
import { useMemo } from 'react';

export const useTimesheetSummary = () => {
  const timesheetRows = useAppSelector(selectTimesheetRows);
  const result = useMemo(() => {
    let totalHours = 0;
    let totalBillable = 0;
    let totalNonbillable = 0;
    (timesheetRows.data || []).map((row) => {
      (row.entries || []).map((entry) => {
        const duration = Number.parseInt(`${entry.duration || 0}`, 10);
        totalHours += duration;
        if (entry.billable) {
          totalBillable += duration;
        } else {
          totalNonbillable += duration;
        }
        return null;
      });
      return null;
    });

    return {
      total: totalHours,
      billable: totalBillable,
      nonBillable: totalNonbillable,
    };
  }, [timesheetRows.data]);
  return result;
};
